import { useApi } from '../../../../../core/api/api.context';
import { useMutation, useQueryClient } from 'react-query';
import { EditProjectMembershipDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { QueryKeys } from '../../../../../core/queries/query-keys.constants';

export const useMutationUpdateRole = (projectID: string, userID: string) => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation(async (submissionData: EditProjectMembershipDto) => {
    const result = await api.projectsController.teamMembersEdit(projectID, userID, submissionData);
    await queryClient.invalidateQueries([QueryKeys.ACCOUNTS]);
    await queryClient.invalidateQueries([QueryKeys.PROJECTS, projectID, QueryKeys.TEAM_MEMBERS]);
    return result;
  });
};
